




























































import { updateEnrollee } from '@adobe/edex/frontend/api/course';

export default {
  name: 'bulk-actions',
  props: {
    selected: {
      default: () => {
        return new Set();
      },
      type: Set,
    },
    courseID: {
      required: true,
      type: String,
    },
    canRemove: {
      required: true,
      type: Boolean,
    },
  },
  data() {
    return {
      show: false,
      action: '',
      comment: '',
      loading: false,
      removeConfirmed: false,
    };
  },
  computed: {
    hasSelected() {
      return Boolean(this.selected.size);
    },
    showComment() {
      return this.action === 'passed';
    },
  },
  watch: {
    selected(current, previous) {
      if (current.size === previous.size) {
        this.action = '';
        this.comment = '';
      }
    },
  },
  methods: {
    selectAction(e) {
      this.action = e.target.value;
    },
    async submit() {
      if (this.action == 'removed' && !this.removeConfirmed) {
        return this.$modal.show('dialog', {
          title: `Remove ${this.selected.size} enrollees?`,
          buttons: [
            {
              title: 'Cancel',
              handler: () => {
                this.action = '';
                this.$modal.hide('dialog');
              },
            },
            {
              title: 'Confirm',
              default: true, // Will be triggered by default if 'Enter' pressed.
              handler: () => {
                this.removeConfirmed = true;
                this.submit();
                this.$modal.hide('dialog');
              },
              class: 'btn btn-primary',
            },
          ],
        });
      }

      let errorCount = 0;
      let successCount = 0;

      this.loading = true;

      const updatedRows = [];

      await Promise.all(
        [...this.selected].map(async memberID => {
          try {
            const payload = {
              memberID,
              status: this.action,
              reviewComment: this.comment,
            };

            const { data } = await updateEnrollee(this.courseID, payload);

            if (data) {
              successCount += 1;
              updatedRows.push(data);
              if (errorCount + successCount === this.selected.size) {
                this.loading = false;
                this.removeConfirmed = false;
              }
            }
          } catch (error) {
            errorCount += 1;
            if (errorCount + successCount === this.selected.size) {
              this.$emit('onBulkActionError', errorCount);
              this.loading = false;
              this.removeConfirmed = false;
            }
          }
        })
      );

      this.$emit('onBulkActionSuccess', updatedRows);
    },
  },
};
